<ras-page>
	<main>
		<h1>Careers</h1>

		<p class="lead">We employ efficient, clear headed and enthusiastic staff who can help us provide service excellence.</p>

		<p>Rent-A-Store is South Africa’s leading self storage company and we’re expanding. We employ efficient, clear headed and enthusiastic staff who can help us provide Rent-A-Store customers with service excellence.</p>
		<p>Think you’ve got what it takes?</p>
		<p>Experience in the self storage industry is a plus! Email your CV to us, using the relevant email address below, and provide a 100 word summary on why you would be a valuable asset to the Rent-A-Store team.</p>
		<p>We look forward to receiving your information, and will contact you should a relevant job opportunity become available that we think would excite you.</p>

		<br>

		<h3>Client services, sales and administration</h3>
		<p>From helping clients select the best self storage solution for their needs over the phone or in person, to processing the necessary documentation efficiently, our client services teams work together to make the Rent-A-Store customer experience fast, simple, and friendly.</p>
		<p>Email: <a href="mailto:career@rentastore.co.za">career&#64;rentastore.co.za</a></p>

		<br>

		<h3>Facilities managers</h3>
		<p>Our sites are clean and tidy, and our facilities are user friendly, secure and well maintained. Our customers appreciate our consistently high standards.</p>
		<p>Email: <a href="mailto:career@rentastore.co.za">career&#64;rentastore.co.za</a></p>

		<br>

		<h3>Truck drivers</h3>
		<p>Our code 10 drivers are carefully screened for faultless driving ability. Working with customers to ensure that their belongings can be transported as efficiently as possible is key to our free move in transport service.</p>
		<p>Email: <a href="mailto:career@rentastore.co.za">career&#64;rentastore.co.za</a></p>

		<br>

		<h3>Maintenance personnel</h3>
		<p>Our maintenance teams are involved in diverse activities from gardening to building repairs to ensure that our storage sites are always in top shape.</p>
		<p>Email: <a href="mailto:career@rentastore.co.za">career&#64;rentastore.co.za</a></p>
	</main>
</ras-page>
